import React, { PureComponent } from "react";
// import classnames from "classnames";
import moment from "moment";
import _ from "i18n";

import { TiCogOutline, TiTickOutline, TiWarningOutline } from "react-icons/ti";
// import { getFormatNumber } from "Utils";
// import { SIGN, STATUS } from "Config";

import { Tooltip } from "antd";
import { BudgetIcon, EntityIcon } from "../Common/Icons";
// import PercentageStatus from "../Common/Percentage/PercentageStatus";

import styles from "./Item.local.scss";
import NumberFormat from "react-number-format";
import { display_number_format } from "Utils";

import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import classnames from "classnames";
import WarningList from "./WarningList";

class Item extends PureComponent {
  render() {
    let { item, erpData, parameterSettings } = this.props;

    let erpId = "";
    let erpLabel = "";
    if (
      erpData.length > 0 ||
      (erpData.clients !== undefined && erpData.clients.length > 0)
    ) {
      let cliErpData = erpData.clients.filter(
        client => Object.keys(client)[0] === item.id.toString()
      );
      erpId = cliErpData[0] && cliErpData[0][item.id]["erpId"];
      erpLabel = cliErpData[0] && cliErpData[0][item.id]["erpLabel"];
    }

    let styleCercle = {};
    let status = "";
    switch (item.budgetState) {
      case "GLOBAL_BUDGET_NOT_AFFECTED": {
        status = _("globalBudgetNotAffected");
        break;
      }
      case "GLOBAL_BUDGET_AFFECTED": {
        status = _("globalBudgetAffected");
        break;
      }
      case "BUDGET_BY_ZONE_AFFECTED": {
        status = _("budgetByZoneAffected");
        break;
      }
      case "BUDGET_ZONE_DELEGATION_AFFECTED": {
        status = _("budgetZoneDelegationAffected");
        break;
      }
      case "DELEGATION_NOT_AFFECTED": {
        status = _("delegationNotAffected");
        break;
      }
      // case "BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED": {
      //   status = _("budgetZoneByCategoryNotCompleted");
      //   break;
      // }
      case "BUDGET_COMPLETED": {
        status = _("budgetCompleted");
        styleCercle = {
          borderColor: item.color
        };
        break;
      }
      default: {
        status = _("globalBudgetNotAffected");
      }
    }

    return (
      <div
        key={item.id}
        className={`${styles.list_item} `}
        style={{
          borderColor:
            item.isEntityClient && !item["isDeleted"] ? item.color : ""
        }}
      >
        <div className={`medium-1 ${styles.check}`}>
          <img alt={""} src={"/img/icons/folder.svg"} />
        </div>
        <div
          className="medium-2"
          style={{ marginLeft: "-2%", marginRight: "2%" }}
        >
          <div className={styles.list_item__header}>
            {item.name}

            {erpData.length > 0 ||
            (erpData.clients !== undefined && erpData.clients.length > 0) ? (
              <Tooltip
                placement="bottom"
                title={
                  <div style={{ textAlign: "left", width: "200%" }}>
                    <div>
                      {_("importedFrom")} : {erpLabel}
                    </div>
                    <div>
                      {_("identifier")} : {erpId}
                    </div>
                  </div>
                }
              >
                <img
                  data-for="info__undefined"
                  data-tip=""
                  className={styles.info_icon}
                  src="/img/icons/info.svg"
                  alt=""
                  currentitem="false"
                />{" "}
              </Tooltip>
            ) : (
              ""
            )}
          </div>
          <div className={styles.list_item__sub_header}>{item.group} </div>
          <div className={styles.list_item__header}>
            <Tooltip
              key={`state-${item.id}-1`}
              placement="bottom"
              title={_("budgetConfiguration")}
            >
              <span>
                <i
                  className={`bg-${
                    item.budget1 && item.budget1.id ? "success" : "alert"
                  }`}
                />
              </span>
            </Tooltip>
            <Tooltip
              key={`state-${item.id}-2`}
              placement="bottom"
              title={_("budgetConfiguration")}
            >
              <span>
                <i
                  className={`bg-${
                    item.budget2 && item.budget2.id ? "success" : "alert"
                  }`}
                />
              </span>
            </Tooltip>
          </div>
          <div className={styles.list_item__sub_header_2}>
            {/* {item.regime} • {_("capacity")}: {item.capacity} */}
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <span>
            {/*{item.budget1.total ? `${item.budget1.total} H` : "-"}*/}
            <NumberFormat
              value={item.budget1.total ? item.budget1.total : "-"}
              displayType={"text"}
              format={display_number_format(item.budget1.total)}
            />
          </span>
          <br />
          <span className={styles.percentage_diff}>
            {_("budget")} {item.budget1.year}
          </span>
          <br />
          {item.budget1.id ? (
            <Tooltip
              key={`state-budget-1`}
              placement="bottom"
              title={_("configurated")}
            >
              <span className={styles.success}>
                <TiTickOutline />
              </span>
            </Tooltip>
          ) : parseInt(item.budget1.year, 10) >= moment().year() ? (
            <Tooltip
              key={`state-budget-1`}
              placement="bottom"
              title={_("toConfigurate")}
            >
              <span className={styles.alert}>
                <TiCogOutline />
              </span>
            </Tooltip>
          ) : (
            <Tooltip
              key={`state-budget-1`}
              placement="bottom"
              title={_("notConfigurated")}
            >
              <span className={styles.default}>
                <TiWarningOutline />
              </span>
            </Tooltip>
          )}
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <span>
            {/*{item.budget2.total ? `${item.budget2.total} H` : "-"}*/}
            <NumberFormat
              value={item.budget2.total ? item.budget2.total : "-"}
              displayType={"text"}
              format={display_number_format(item.budget2.total)}
            />
          </span>
          <br />
          <span className={styles.percentage_diff}>
            {_("budget")} {item.budget2.year}
          </span>
          <br />
          {item.budget2.id ? (
            <Tooltip
              key={`state-budget-1`}
              placement="bottom"
              title={_("configurated")}
            >
              <span className={styles.success}>
                <TiTickOutline />
              </span>
            </Tooltip>
          ) : parseInt(item.budget2.year, 10) >= moment().year() ? (
            <Tooltip
              key={`state-budget-1`}
              placement="bottom"
              title={_("toConfigurate")}
            >
              <span className={styles.alert}>
                <TiCogOutline />
              </span>
            </Tooltip>
          ) : (
            <Tooltip
              key={`state-budget-1`}
              placement="bottom"
              title={_("notConfigurated")}
            >
              <span className={styles.default}>
                <TiWarningOutline />
              </span>
            </Tooltip>
          )}
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          {item.isEntityClient ? (
            <EntityIcon color={"#06D9B1"} />
          ) : (
            <EntityIcon color={"#6d7f92"} />
          )}
          <br />
          <span className={styles.percentage_diff}>
            {item.isEntityClient ? (
              <div>{`Client entité`}</div>
            ) : (
              <Tooltip placement="bottom" title={item.entityClient.name}>
                <div
                  style={{ cursor: "pointer" }}
                  key={item.id + "_entityClient"}
                >
                  {"Lié à l'entité: "}{" "}
                  {item.entityClient.name &&
                    item.entityClient.name.slice(0, 25) + "..."}
                </div>
              </Tooltip>
            )}
          </span>
        </div>
        <div className={`medium-4`}>
          <div className={styles.marge}>
            {item.isEntityClient ? (
              item["isDeleted"] ? (
                <div
                  className={styles.list_item__sub_header}
                  style={{ fontSize: 14, alignSelf: "center" }}
                >
                  {_("clientState")}
                </div>
              ) : (
                <div>
                  <span className={styles.text}>{status}</span>
                  <br />
                  <br />
                  <ProgressBar
                    percent={item.pourcentage}
                    filledBackground={item.color}
                    height={7}
                  >
                    <Step transition="scale">
                      {({ accomplished }) => (
                        <div
                          className={classnames(styles.cercle1)}
                          style={{ borderColor: item.color }}
                        >
                          {" "}
                          <span className={styles.spanText}>
                            {item.pourcentage}%
                          </span>
                        </div>
                      )}
                    </Step>

                    <Step transition="scale">
                      {({ accomplished }) => (
                        <div className={styles.cercle3} style={styleCercle} />
                      )}
                    </Step>
                  </ProgressBar>
                </div>
              )
            ) : (
              <div
                className={styles.list_item__sub_header}
                style={{ alignSelf: "center" }}
              >
                {_("NonBudgetise")}
              </div>
            )}
          </div>
        </div>
        <div
          className={`medium-1`}
          style={{
            marginLeft: "-5%"
          }}
        >
          {item.isEntityClient ? (
            <WarningList warnings={item.budgetWarning.split(",")} />
          ) : (
            ""
          )}
        </div>
        {/* <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`aab__${item.id}`} data-tip={"Net assets"}>
            <span>
              {getFormatNumber(item.affectedBudget.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.affectedBudget} />
            </span>
            <div>{_("AnnualAffectedBudget")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div
            data-for={`obc__${item.id}`}
            data-tip={"Degree of financial independence"}
          >
            <span>
              {getFormatNumber(item.outBudget.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.outBudget} />
            </span>
            <div>{_("OutBudgetCompletion")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`ba__${item.id}`} data-tip={"Current ratio"}>
            <span>
              {item.availability.sign === SIGN.NEGATIVE && "-"}
              {getFormatNumber(item.availability.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.availability} />
            </span>
            <div>{_("BudgetaryAvailability")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`ba__${item.id}`} data-tip={"Current ratio"}>
            <span>
              {getFormatNumber(item.annualReleased.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.annualReleased} />
            </span>
            <div>{_("AnnualReleasedCompletion")}</div>
          </div>
        </div>
        <div className={`medium-1 ${styles.list_item__key}`}>
          <div data-for={`ba__${item.id}`} data-tip={"Current ratio"}>
            <span>
              {getFormatNumber(item.currentReleased.value)}
              {"H"}
            </span>
            <br />
            <span className={styles.percentage_diff}>
              <PercentageStatus payload={item.currentReleased} />
            </span>
            <div>{_("CurrentReleasedCompletion")}</div>
          </div>
        </div>
        <div
          className={classnames("medium-2", styles.flex_container)}
          style={{ marginLeft: "-0.5%" }}
        >
          <div className={styles.list__row_groups_cell_wrapper}>
            <div className={classnames(styles.groups_block_position)}>
              <span
                className={styles.list__row_group_cell_tag}
                style={{ fontWeight: 400 }}
              >
                {_("dossierCount")} :{" "}
                {item.outBudget.exception +
                  (item.outBudget.remark
                    ? parseInt(item.outBudget.remark.params, 10)
                    : 0)}
              </span>
              <span className={styles.list__row_group_cell_tag}>
                {parseInt(item.outBudget.exception, 10)} {_("budgeted")}
              </span>
              <span className={styles.list__row_group_cell_tag}>
                {item.outBudget.remark
                  ? parseInt(item.outBudget.remark.params, 10)
                  : 0}{" "}
                {_("nonBudgeted")}
              </span>
            </div>
          </div>
        </div>
        <div
          className={classnames("medium-1", styles.flex_container)}
          style={{ marginLeft: "-2%", marginRight: "2%" }}
        >
          <div className={styles.presentation_info_container}>
            <div className={classnames(styles.presentation_date)}>
              <img alt={""} src={"/img/icons/calendar.svg"} />
              <span>Indicateurs bilan</span>
            </div>
            <div className={classnames(styles.presentation_prepared)}>
              <img alt={""} src={"/img/icons/presentation.svg"} />
              <span>
                <b>{_("indicateurs bilan")}</b>
              </span>
            </div>
          </div>
        </div>*/}
        <div className="medium-1" style={{ marginLeft: "5%" }}>
          <div className={styles.list_item__actions}>
            {item.isEntityClient && (
              <Tooltip
                placement="bottom"
                title={_("configBudget")}
                mouseLeaveDelay={0}
              >
                <div
                  onClick={() =>
                    this.props.handleRedirectBudgetSetting(
                      item,
                      item.budget2.year,
                      item.budgetState
                    )
                  }
                >
                  <BudgetIcon />
                </div>
              </Tooltip>
            )}
            {parameterSettings && !parameterSettings.synchroEntity ? (
              <Tooltip
                placement="bottom"
                title={_("configEntity")}
                mouseLeaveDelay={0}
              >
                <div
                  onClick={() => this.props.handleOpenClientEntitySetting(item)}
                >
                  <EntityIcon />
                </div>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/components/ClientsList/Item.js